import { render, staticRenderFns } from "./bi-person-list.vue?vue&type=template&id=42e8bc24&"
import script from "./bi-person-list.vue?vue&type=script&lang=ts&"
export * from "./bi-person-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports